'use strict';
import Splide from '@splidejs/splide';
import { gsap, Power3, Power0 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { EaselPlugin } from 'gsap/EaselPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { flowBlockLoop } from '../utility/_modules';
gsap.registerPlugin(EaselPlugin, ScrollTrigger, ScrollToPlugin);
const initIndexMagazineSplide = () => {
  const magazineIndexSplideOptions = {
    mediaQuery: 'min',
    type: 'loop',
    // rewind: true,
    perMove: 1,
    perPage: 1.3,
    autoplay: false,
    focus: 'left',
    pagination: false,
    drag: false,
    speed: 1200,
    start: 0,
    updateOnMove: true,
    clones: 0,
    snap: true,
    completely: false,
    breakpoints: {
      750: {
        perPage: 2.2,
        // destroy: true,
      },
    },
  };
  const magazineIndexSplide = new Splide(
    '.magazine-splide',
    magazineIndexSplideOptions
  );
  magazineIndexSplide.mount();
  const slides = document.querySelectorAll('.magazine-splide__wrap');
  let current; // 現在のサムネイルを保持するための変数
  magazineIndexSplide.on('move', () => {
    // 動いた瞬間
    // prev方向なら
    // .is-prevを持っているスライドに、back-activeを付与
    // next方向なら
    // .is-nextを持っているスライドに、to-activeを付与
    console.log('current');
    // const active = slides.classList.contains('is-active');
    // active.classList.add('is-');
    const slide = slides[magazineIndexSplide.index];
    if (slide) {
      slide.classList.add('is-');
      current = slide;
    }
    console.log(slide);
  });
  magazineIndexSplide.on('inactive', () => {
    if (current) {
      current.classList.remove('is-');
    }

    // Splide#indexは現在アクティブなスライドのインデックスを返す
    // const li = paginationLis[parentSplide.index];

    // if (li) {
    //   li.classList.add('is-active');
    //   current = li;
    // }
  });
};

const initloading = () => {
  const header = document.querySelector('.header');
  const kvCopyMain = document.querySelector('.kv-copy__title');
  const kvCopySub = document.querySelector('.kv-copy__text');
  const contactButton = document.querySelector('.kv-contact');

  const loadingTl = gsap.timeline();
  loadingTl
    .set(header, {
      y: '-100%',
    })
    .add(() => {
      kvCopyMain.classList.add('is-active');
    })
    // クリップマスク出てくる
    .add(() => {
      kvCopySub.classList.add('is-active');
    }, '+=.5')
    // 虫眼鏡ズームアップできえる
    .add(() => {
      contactButton.classList.add('is-active');
    }, '<')

    .to(
      header,
      {
        y: 0,
      },
      '+=.5'
    );
};

window.addEventListener('DOMContentLoaded', () => {
  initIndexMagazineSplide();
  flowBlockLoop();
});
